<template>
    <div>
        <button class="btn btn-sm btn-gray text-sm py-1 px-2 flex items-center" @click="popup()">
            <Icon name="material-symbols:thumb-up-outline" class="mr-1" />
            Feedback
        </button>

        <!-- HTML Markup -->
        <div class="absolute h-screen " v-if="open">
            <!-- Rest of the page content -->

            <!-- Modal Overlay -->
            <div class="fixed inset-0 z-50 bg-[var(--black)] opacity-50"></div>

            <!-- Modal Container -->
            <div class="fixed inset-0 flex items-center justify-center z-50 ">
                <!-- Modal Content -->
                <div class="bg-[var(--dark-gray)] p-6 rounded-md shadow-xl">
                    <!-- Modal Content Goes Here -->
                    <h1 class="text-2xl font-bold mb-4">Was this page helpful?</h1>

                    <button class="btn border mr-2 mt-4 mb-4 text-light-gray" @click="sentiment = true"
                        :class="sentiment === true ? 'btn-primary' : ''">
                        <Icon name="material-symbols:thumb-up-outline" />
                        Yes
                    </button>
                    <button class="btn border text-light-gray" @click="sentiment = false"
                        :class="sentiment === false ? 'btn-primary' : ''">
                        <Icon name="material-symbols:thumb-down-outline" />
                        No
                    </button>

                    <p class="text-medium-gray" v-if="sentiment !== undefined">Tell us more.</p>
                    <textarea class="w-full h-32 border border-[var(--light-gray)] rounded-md p-2" v-model="feedback"
                        v-if="sentiment !== undefined"></textarea>

                    <div class="mt-4">
                        <button class="btn btn-primary ease-in-out mr-2 disabled:bg-[var(--secondary-blue)]"
                            :disabled="sentiment === undefined" @click="submit">
                            Submit
                        </button>
                        <button class="btn btn-secondary ease-in-out" @click="popup()">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
export default {
    data() {
        return {
            open: false,
            feedback: '',
            sentiment: undefined as boolean | undefined,
        };
    },
    methods: {
        popup() {
            this.open = !this.open;
            this.sentiment = undefined;
            this.feedback = '';
        },
        submit() {
            console.log('submit');
            window.open(
                `mailto:hello@unified.to?subject=${this.sentiment === true ? 'Positive' : 'Negative'}%20Feedback&body=${encodeURIComponent(
                    'My feedback on ' + window.location.href + '\n\n' + this.feedback
                )}`
            );
            this.popup();
        },
    },
};
</script>